import { AddressErrors } from '@/components/blocks/AddressForm/types';
import { EMPTY_STRING } from '@/data/constants/marketing';
import { EditableAddress } from '@/data/types/Address';
import { FormState } from '@/utils/useForm';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { isNoExteriorNumber, NO_EXTERIOR_NUMBER_VALUE } from 'shared/custom/utils/exteriorNumber';

type UseNoExteriorNumberProps = {
	exteriorNumber: string;
	onNamedValueChange: FormState<EditableAddress>['onNamedValueChange'];
	setAddressErrors: Dispatch<SetStateAction<AddressErrors>>;
	setIsEdited: Dispatch<SetStateAction<boolean>>;
};

export const useNoExteriorNumber = ({
	exteriorNumber,
	onNamedValueChange,
	setAddressErrors,
	setIsEdited,
}: UseNoExteriorNumberProps) => {
	const [isNoExteriorNumberChecked, setIsNoExteriorNumberChecked] = useState(() =>
		isNoExteriorNumber(exteriorNumber)
	);

	const handleNoExteriorNumberChange = useCallback(
		(checked: boolean) => {
			setIsNoExteriorNumberChecked(checked);
			onNamedValueChange('addressLine2', checked ? NO_EXTERIOR_NUMBER_VALUE : EMPTY_STRING);
			setAddressErrors((prevState) => ({ ...prevState, exteriorNumber: false }));
			setIsEdited(true);
		},
		[onNamedValueChange, setAddressErrors, setIsEdited]
	);

	return { isNoExteriorNumberChecked, handleNoExteriorNumberChange };
};
